import React from 'react';
import logo from '../assets/logozamintech.png'
import { useState } from "react";
import { Menu, X } from "lucide-react"; // íconos de Lucide

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);

  return (
      <header className="fixed top-0 w-full bg-white shadow z-50">
        <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">
          <img src={logo} alt="Logo Zamintech" className="h-10 w-auto" />

          {/* Botón hamburguesa visible solo en móviles */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-gray-700 focus:outline-none"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>

          {/* Menú de navegación */}
          <nav className={`md:flex space-x-6 ${isOpen ? 'block' : 'hidden'} md:block absolute md:static bg-white left-0 top-16 w-full md:w-auto p-4 md:p-0 shadow md:shadow-none`}>
            <a className="block md:inline hover:text-blue-600 py-2"></a>
            <a href="/" className="block md:inline hover:text-blue-600 py-2">Inicio</a>
            <a href="#servicios" className="block md:inline hover:text-blue-600 py-2">Servicios</a>
            <a href="#equipos" className="block md:inline hover:text-blue-600 py-2">Equipos</a>
            <a href="/docs" className="block md:inline hover:text-blue-600 py-2">Documentación</a>
            <a href="#contacto" className="block md:inline hover:text-blue-600 py-2">Contacto</a>
          </nav>
        </div>
      </header>
  );
}
